var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9602 38.5601H60.9602C61.7028 38.5601 62.415 38.8551 62.9401 39.3802C63.4652 39.9053 63.7602 40.6175 63.7602 41.3601V60.9601C63.7602 61.7027 63.4652 62.4149 62.9401 62.94C62.415 63.4651 61.7028 63.7601 60.9602 63.7601H32.9602C32.2175 63.7601 31.5054 63.4651 30.9803 62.94C30.4552 62.4149 30.1602 61.7027 30.1602 60.9601V41.3601C30.1602 40.6175 30.4552 39.9053 30.9803 39.3802C31.5054 38.8551 32.2175 38.5601 32.9602 38.5601Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4602 30.1602H43.4602C42.7175 30.1602 42.0054 30.4552 41.4803 30.9803C40.9552 31.5054 40.6602 32.2175 40.6602 32.9602V38.5602H53.2602V32.9602C53.2602 32.2175 52.9652 31.5054 52.4401 30.9803C51.915 30.4552 51.2028 30.1602 50.4602 30.1602Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 46.9601C0.754859 43.8344 1.53367 40.7584 3.01691 38.007C4.50015 35.2555 6.64164 32.9142 9.25019 31.192C11.8587 29.4698 14.8532 28.4203 17.9661 28.1373C21.0791 27.8543 24.2136 28.3466 27.09 29.5701",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6.44C11.5407 8.29368 13.6864 9.76784 16.059 10.7746C18.4316 11.7814 20.9826 12.3002 23.56 12.3C26.1521 12.2971 28.7169 11.7698 31.1 10.75",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2098 12.3C31.2118 14.5868 30.5355 16.8228 29.2665 18.7251C27.9975 20.6275 26.1927 22.1107 24.0806 22.9872C21.9685 23.8637 19.6438 24.094 17.4007 23.6491C15.1577 23.2042 13.0969 22.104 11.4792 20.4877C9.86154 18.8714 8.75956 16.8116 8.3127 14.5689C7.86585 12.3262 8.09419 10.0014 8.96884 7.88849C9.8435 5.7756 11.3252 3.96958 13.2264 2.69891C15.1277 1.42824 17.3631 0.750001 19.6498 0.75C22.714 0.749999 25.6528 1.96655 27.8205 4.13231C29.9881 6.29807 31.2072 9.23583 31.2098 12.3V12.3Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.65 28.06V46.96",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCx);
export default __webpack_public_path__ + "static/media/add_cx.0ce87ae49764c47d2400fb3569535bd6.svg";
export { ForwardRef as ReactComponent };